"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bus_rdf_resolve_quad_pattern_1 = require("@comunica/bus-rdf-resolve-quad-pattern");
/**
 * Comunica datasource utilities
 */
class DataSourceUtils {
    /**
     * Get the single source if the context contains just a single source.
     * @param {ActionContext} context A context, can be null.
     * @return {Promise<IDataSource>} A promise resolving to the single datasource or null.
     */
    static async getSingleSource(context) {
        if (context && context.has(bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCE)) {
            // If the single source is set
            return context.get(bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCE);
        }
        else if (context && context.has(bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCES)) {
            // If multiple sources are set
            const datasources = context.get(bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCES);
            if (datasources.isEnded()) {
                // Now get the first source
                const datasourcesArray = await require('arrayify-stream')(datasources.iterator());
                if (datasourcesArray.length === 1) {
                    return datasourcesArray[0];
                }
            }
        }
        return null;
    }
    /**
     * Get the type of a single source
     * @param {ActionContext} context A context, can be null.
     * @return {Promise<string>} A promise resolving to the type of the source, can be null if source is null.
     */
    static async getSingleSourceType(context) {
        const source = await this.getSingleSource(context);
        return source ? bus_rdf_resolve_quad_pattern_1.getDataSourceType(source) : null;
    }
    /**
     * Check if the given context has a single source of the given type.
     * @param {ActionContext} context An optional context.
     * @param {string} requiredType The required source type name.
     * @return {boolean} If the given context has a single source of the given type.
     */
    static async singleSourceHasType(context, requiredType) {
        const actualType = await this.getSingleSourceType(context);
        const result = actualType ? actualType === requiredType : false;
        return result;
    }
}
exports.DataSourceUtils = DataSourceUtils;
//# sourceMappingURL=DataSourceUtils.js.map